"use strict";

exports.__esModule = true;
exports.readableUrl = exports.normalizeUrl = void 0;

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// normalizes url for unicode support in server side
var normalizeUrl = function normalizeUrl(url) {
  return new _urijs["default"](url).normalize().toString();
}; // decodes origin and pathname to readable unicode characters
// cannot decode search as it might contain encoded '#' character


exports.normalizeUrl = normalizeUrl;

var readableUrl = function readableUrl(uri) {
  var url = new _urijs["default"](uri);
  var readablePart = new _urijs["default"](url.origin() + url.pathname()).readable();
  return readablePart + url.search() + url.hash();
};

exports.readableUrl = readableUrl;